import { ProfileEffects } from './profile.effect';

export const effects: any[] = [ProfileEffects];

export * from './profile.effect';
